module.exports = __webpack_public_path__ + "img/search_slide_3.eaf70282.png";